import { useRef } from 'react';

/** Ref vždy drží aktuální hodnotu — stabilní reference pro async callbacky. */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
